import React from "react";

import GnbMenuWrapper from "../util/GnbMenuWrapper";
import FirstDepthMenu from "./content/firstDepthMenu/FirstDepthMenu";
import SecondDepthMenu from "./content/secondDepthMenu/SecondDepthMenu";

function DropdownMenu(props) {
    const {
        menuInfo,
        currentMenuInfo,
        changeFirstDepthMenu,
        changeSecondDepthMenu,
        isSubMenuOpen,
        toggleSubMenu,
        isSecondDepthSubMenuOpen,
        toggleSecondDepthSubMenu,
    } = props;

    return (
        <GnbMenuWrapper isSelect={true}>
            <FirstDepthMenu
                itemList={menuInfo}
                isSubMenuOpen={isSubMenuOpen}
                toggleSubMenu={toggleSubMenu}
                changeFirstDepthMenu={changeFirstDepthMenu}
                currentMenuInfo={currentMenuInfo.firstDepth}
            />
            <SecondDepthMenu
                itemList={
                    menuInfo.find((info) => currentMenuInfo.firstDepth.MENU_CD === info.MENU_CD)?.SUB_MENU_LIST || []
                }
                isSecondDepthSubMenuOpen={isSecondDepthSubMenuOpen}
                toggleSecondDepthSubMenu={toggleSecondDepthSubMenu}
                changeSecondDepthMenu={changeSecondDepthMenu}
                currentMenuInfo={currentMenuInfo.secondDepth}
            />
        </GnbMenuWrapper>
    );
}

export default DropdownMenu;
